import React, { Component } from "react";
import { DATACENTER_LOCATIONS } from "utils/CommonConstants";
import Test from "./MapLabel";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const MapImg = `${CDN_URL}common/SOUTHEASTMAP.svg`;

const AtlantaBuilding = `${CDN_URL}common/Atlanta-buidling.svg`;
const ChattanoogaBuilding = `${CDN_URL}common/Chattanooga-building.svg`;
const HuntsvilleBuilding = `${CDN_URL}common/Huntsville-building.svg`;
const BirminghamBuilding = `${CDN_URL}common/Birmingham-building.svg`;
const GreenvilleBuilding = `${CDN_URL}common/Chattanooga-building.svg`;

class Map extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locationImage: "",
      location: "",
      Hover: "",
      ATLHOVER: {
        location: "ATLANTA",
        colorFill1: "#583a6b",
        colorFill2: "#8134c3",
        width: "43.001",
        fontColor: "#b4d334",
        x: "15",
      },
      CHATHOVER: {
        location: "CHATTANOOGA",
        colorFill1: "#583a6b",
        colorFill2: "#8134c3",
        fontColor: "#b4d334",
        width: "64.793",
        x: "5",
      },
      HUNTHOVER: {
        location: "HUNTSVILLE",
        colorFill1: "#583a6b",
        colorFill2: "#8134c3",
        fontColor: "#b4d334",
        width: "64.793",
        x: "10",
      },
      BIRMINGHAMHOVER: {
        location: "BIRMINGHAM",
        colorFill1: "#583a6b",
        colorFill2: "#8134c3",
        fontColor: "#b4d334",
        width: "64.793",
        x: "10",
      },
      GREENVILLEHOVER: {
        location: "GREENVILLE",
        colorFill1: "#583a6b",
        colorFill2: "#8134c3",
        fontColor: "#b4d334",
        width: "64.793",
        x: "10",
      },
      MYRTLEHOVER: {
        location: "MYRTLE BEACH",
        colorFill1: "#583a6b",
        colorFill2: "#8134c3",
        fontColor: "#b4d334",
        width: "64.793",
        x: "5",
      },
    };
  }

  onMouseOver = (location) => {
    this.setState({ Hover: location });
  };

  onClick = (location) => {
    const { onChange } = this.props;
    const locationImage = this.getLocationImage(location);
    if (onChange) {
      onChange(location);
    }
    this.setState({ locationImage, location });
  };

  getLocationImage = (location) => {
    if (location === "Atlanta" || location === "ATL") {
      return {
        location: "ATLANTA",
        colorFill1: "#b4d334",
        colorFill2: "#949300",
        width: "43.001",
        x: "17",
      };
    } else if (location === "Huntsville" || location === "HSV") {
      return {
        location: "HUNTSVILLE",
        colorFill1: "#b4d334",
        colorFill2: "#949300",
        width: "64.793",
        x: "12",
      };
    } else if (location === "Birmingham" || location === "BHM") {
      return {
        location: "BIRMINGHAM",
        colorFill1: "#b4d334",
        colorFill2: "#949300",
        width: "64.793",
        x: "12",
      };
    } else if (location === "Chatanooga" || location === "CHA") {
      return {
        location: "CHATTANOOGA",
        colorFill1: "#b4d334",
        colorFill2: "#949300",
        width: "64.793",
        x: "6",
      };
    } else if (location === "Greenville" || location === "GSP") {
      return {
        location: "GREENVILLE",
        colorFill1: "#b4d334",
        colorFill2: "#949300",
        width: "64.793",
        x: "6",
      };
    }
  };

  onMouseOut = () => {
    this.setState({ Hover: "" });
  };

  componentDidUpdate() {
    const { location: incomingLocation } = this.props;
    const { location: existingLocation } = this.state;

    if (existingLocation !== incomingLocation) {
      const locationImage = this.getLocationImage(incomingLocation);
      this.setState({ location: incomingLocation, locationImage });
    }
  }
  componentDidMount() {
    const { location: incomingLocation } = this.props;
    const locationImage = this.getLocationImage(incomingLocation);
    this.setState({ location: incomingLocation, locationImage });
  }

  checkService = (locationTag) => {
    const { services } = this.props;
    const lowerCaseTag = locationTag.toLowerCase();

    const filteredServiceByTag =
      services &&
      services.filter(
        (coService) => coService?.datacenterName.toLowerCase() === lowerCaseTag
      );
    if (filteredServiceByTag && filteredServiceByTag.length !== 0) {
      return true;
    } else {
      return false;
    }
  };

  getHover = (tag) => {
    const {
      HUNTHOVER,
      ATLHOVER,
      BIRMINGHAMHOVER,
      GREENVILLEHOVER,
      CHATHOVER,
      MYRTLEHOVER,
    } = this.state;
    switch (tag) {
      case "ATL":
        return ATLHOVER;
      case "HSV":
        return HUNTHOVER;
      case "BHM":
        return BIRMINGHAMHOVER;
      case "GSP":
        return GREENVILLEHOVER;
      case "CHA":
        return CHATHOVER;
      case "MYR":
        return MYRTLEHOVER;
      default:
        return CHATHOVER;
    }
  };

  getBuildingImg = (tag) => {
    switch (tag) {
      case "ATL":
        return AtlantaBuilding;
      case "HSV":
        return HuntsvilleBuilding;
      case "BHM":
        return BirminghamBuilding;
      case "GSP":
        return GreenvilleBuilding;
      case "CHA":
        return ChattanoogaBuilding;
      case "MYR":
        return ChattanoogaBuilding;
      default:
        return BirminghamBuilding;
    }
  };

  renderLocation = (datacenter, index) => {
    const { location, Hover } = this.state;

    return (
      <>
        {location === datacenter?.tag ? (
          <div className={`dot dot-${index + 1}`}>
            {" "}
            <img
              id={`${datacenter.tag}-building`}
              src={this.getBuildingImg(datacenter.tag)}
            />{" "}
          </div>
        ) : (
          <div
            onMouseOut={() => this.onMouseOut()}
            onMouseOver={() => this.onMouseOver(datacenter.location)}
            onClick={() => this.onClick(datacenter.tag)}
            className={`dot dot-${index + 1}`}
            data-cy={`${datacenter.tag}-map`}
            id={`${datacenter.tag}-map`}
          >
            {Hover === datacenter.location && (
              <div id={`dot-${index + 1}`}>
                <Test location={this.getHover(datacenter.tag)} />{" "}
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  render() {
    return (
      <div className="map-wrapper">
        <img id="map-image" src={MapImg} />
        {DATACENTER_LOCATIONS.map(
          (datacenter, index) =>
            this.checkService(datacenter.tag) &&
            this.renderLocation(datacenter, index + 1)
        )}
      </div>
    );
  }
}

export default Map;
